import type { Theme } from '@mui/material'

const monoUppercase = (theme: Theme) => ({
  fontFamily: theme.app.monoFontFamily,
  textTransform: 'uppercase' as const,
})

export const monoLabelSx = (theme: Theme) => ({
  ...monoUppercase(theme),
  fontSize: 11,
  color: 'neutral.gray',
})

export const monoTinyLabelSx = (theme: Theme) => ({
  ...monoUppercase(theme),
  fontSize: 10,
  color: 'neutral.mediumGray',
})

export const monoCaptionSx = (theme: Theme) => ({
  fontFamily: theme.app.monoFontFamily,
  fontSize: 12,
  color: 'common.black',
})

export const monoButtonSx = (theme: Theme) => ({
  ...monoUppercase(theme),
  fontSize: 12,
  fontWeight: 600,
  py: '13px',
})

export const monoSmallButtonSx = (theme: Theme) => ({
  ...monoUppercase(theme),
  fontSize: 11,
})

export const monoHelperSx = (theme: Theme) => ({
  fontFamily: theme.app.monoFontFamily,
  fontSize: 11,
  color: 'neutral.mediumGray',
})
